import {ColDef} from 'ag-grid-community';

// Substitui o AgGridColumn removido no ag-grid 31: declara a coluna como filho do Grid, que a converte em columnDefs.
export type AgGridColumnProps = ColDef & {children?: never};

export const AgGridColumn = (_props: AgGridColumnProps): null => null;

export default AgGridColumn;
